// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes show {
  0% {
    opacity: 0.2;
    transform: translateX(80px);
  }

  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

.survey-option {
  display: flex;
  align-items: center;
  background-color: var(--survey-option-background);
  max-height: 92px;
  padding: 20px 16px;
  border-radius: 12px;
  position: relative;
  cursor: pointer;
  color: var(--survey-option-color);
  animation-name: show;
  -webkit-animation-name: show;
  animation-timing-function: ease-in-out;
  transition: background-color 0.3s;
  -webkit-transition: background-color 0.3s;
  border: 1px solid transparent;

  z-index: 5;
}
.survey-option:nth-child(1) {
  animation-duration: 0.2s;
}
.survey-option:nth-child(2) {
  animation-duration: 0.4s;
}
.survey-option:nth-child(3) {
  animation-duration: 0.6s;
}
.survey-option:nth-child(4) {
  animation-duration: 0.8s;
}
.survey-option:nth-child(5) {
  animation-duration: 1s;
}
.survey-option:nth-child(6) {
  animation-duration: 1.2s;
}
.survey-option:nth-child(7) {
  animation-duration: 1.4s;
}
.survey-option:nth-child(8) {
  animation-duration: 1.6s;
}
.survey-option:nth-child(9) {
  animation-duration: 1.8s;
}
.survey-option:nth-child(10) {
  animation-duration: 2s;
}
.survey-option:nth-child(11) {
  animation-duration: 2.2s;
}
.survey-option:nth-child(12) {
  animation-duration: 2.4s;
}
.survey-option:nth-child(13) {
  animation-duration: 2.6s;
}
.survey-option:nth-child(14) {
  animation-duration: 2.8s;
}
.survey-option:nth-child(15) {
  animation-duration: 3s;
}

.survey-option:has(div:nth-child(3)) {
  justify-content: space-between;
}

.survey-option .circle-container {
  width: 25px;
  height: 24px;
  border-radius: 50%;
  background-color: transparent;
  border: 1px solid #CDCED2;
  box-sizing: border-box;
}

@media (min-width: 1280px) {
  .survey-option:hover {
    background-color: var(--survey-option-background-hover);
  }
}

.survey-option.selected {
  background-color: var(--survey-option-background-selected);
  color: var(--survey-option-color-selected);
  border: 1px solid var(--survey-option-border-color-selected);
}

.survey-option.background-image {
  max-height: none;
}

/* inside survey-option */
.survey-option img {
  width: 52px;
  height: 52px;
  margin-right: 16px;
}

.survey-option:has(.content:not(:last-child)) img {
  margin-right: auto;
}

.survey-option .content {
  display: flex;
  flex-direction: column;
}

.survey-option .content:not(:last-child) {
  width: 192px;
}

.survey-option .content .title {
  font-size: 17px;
  line-height: 22px;
  font-weight: var(--survey-option-content-font-weight);
}

.survey-option.selected .content .title {
  font-weight: 700;
  color: var(--black);
}

.survey-option .content .description {
  font-size: 13px;
  font-weight: 400;
  line-height: 18px;

  color: var(--dark-gray);
}

.survey-option .state-indicator {
  --option-indicator-size: 22px;
}

.page-areas-to-focus .survey-option .state-indicator svg {
  height: var(--option-indicator-size);
  width: var(--option-indicator-size);
}
`, "",{"version":3,"sources":["webpack://./src/orgfit/pilates-3-ltp/css/components/components.option.css"],"names":[],"mappings":"AAAA;EACE;IACE,YAAY;IACZ,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iDAAiD;EACjD,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,iCAAiC;EACjC,oBAAoB;EACpB,4BAA4B;EAC5B,sCAAsC;EACtC,iCAAiC;EACjC,yCAAyC;EACzC,6BAA6B;;EAE7B,UAAU;AACZ;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE;IACE,uDAAuD;EACzD;AACF;;AAEA;EACE,0DAA0D;EAC1D,0CAA0C;EAC1C,4DAA4D;AAC9D;;AAEA;EACE,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,qDAAqD;AACvD;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;;EAEjB,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;EACpC,mCAAmC;AACrC","sourcesContent":["@keyframes show {\n  0% {\n    opacity: 0.2;\n    transform: translateX(80px);\n  }\n\n  100% {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n.survey-option {\n  display: flex;\n  align-items: center;\n  background-color: var(--survey-option-background);\n  max-height: 92px;\n  padding: 20px 16px;\n  border-radius: 12px;\n  position: relative;\n  cursor: pointer;\n  color: var(--survey-option-color);\n  animation-name: show;\n  -webkit-animation-name: show;\n  animation-timing-function: ease-in-out;\n  transition: background-color 0.3s;\n  -webkit-transition: background-color 0.3s;\n  border: 1px solid transparent;\n\n  z-index: 5;\n}\n.survey-option:nth-child(1) {\n  animation-duration: 0.2s;\n}\n.survey-option:nth-child(2) {\n  animation-duration: 0.4s;\n}\n.survey-option:nth-child(3) {\n  animation-duration: 0.6s;\n}\n.survey-option:nth-child(4) {\n  animation-duration: 0.8s;\n}\n.survey-option:nth-child(5) {\n  animation-duration: 1s;\n}\n.survey-option:nth-child(6) {\n  animation-duration: 1.2s;\n}\n.survey-option:nth-child(7) {\n  animation-duration: 1.4s;\n}\n.survey-option:nth-child(8) {\n  animation-duration: 1.6s;\n}\n.survey-option:nth-child(9) {\n  animation-duration: 1.8s;\n}\n.survey-option:nth-child(10) {\n  animation-duration: 2s;\n}\n.survey-option:nth-child(11) {\n  animation-duration: 2.2s;\n}\n.survey-option:nth-child(12) {\n  animation-duration: 2.4s;\n}\n.survey-option:nth-child(13) {\n  animation-duration: 2.6s;\n}\n.survey-option:nth-child(14) {\n  animation-duration: 2.8s;\n}\n.survey-option:nth-child(15) {\n  animation-duration: 3s;\n}\n\n.survey-option:has(div:nth-child(3)) {\n  justify-content: space-between;\n}\n\n.survey-option .circle-container {\n  width: 25px;\n  height: 24px;\n  border-radius: 50%;\n  background-color: transparent;\n  border: 1px solid #CDCED2;\n  box-sizing: border-box;\n}\n\n@media (min-width: 1280px) {\n  .survey-option:hover {\n    background-color: var(--survey-option-background-hover);\n  }\n}\n\n.survey-option.selected {\n  background-color: var(--survey-option-background-selected);\n  color: var(--survey-option-color-selected);\n  border: 1px solid var(--survey-option-border-color-selected);\n}\n\n.survey-option.background-image {\n  max-height: none;\n}\n\n/* inside survey-option */\n.survey-option img {\n  width: 52px;\n  height: 52px;\n  margin-right: 16px;\n}\n\n.survey-option:has(.content:not(:last-child)) img {\n  margin-right: auto;\n}\n\n.survey-option .content {\n  display: flex;\n  flex-direction: column;\n}\n\n.survey-option .content:not(:last-child) {\n  width: 192px;\n}\n\n.survey-option .content .title {\n  font-size: 17px;\n  line-height: 22px;\n  font-weight: var(--survey-option-content-font-weight);\n}\n\n.survey-option.selected .content .title {\n  font-weight: 700;\n  color: var(--black);\n}\n\n.survey-option .content .description {\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 18px;\n\n  color: var(--dark-gray);\n}\n\n.survey-option .state-indicator {\n  --option-indicator-size: 22px;\n}\n\n.page-areas-to-focus .survey-option .state-indicator svg {\n  height: var(--option-indicator-size);\n  width: var(--option-indicator-size);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
